<div class="container not-found-wrap text-center py-5">
  <h1 class="not-found-title">Page not found</h1>
  <p class="not-found-text">
    The page you are looking for doesn't exist or may have been moved.
  </p>
  <div class="not-found-actions">
    <a routerLink="/" class="btn btn-primary">Go to homepage</a>
    <a routerLink="/tech-blogs/blog" class="btn btn-outline-primary ms-2">Read our blog</a>
  </div>
</div>
